export type ChannelCategory = {
  uuid: string
  slug: string
  name: string
  channelsCount?: number
}

/** Псевдо-слаг для фильтра «без категории». Совпадает с ports.NoCategorySlug на бэке. */
export const NO_CATEGORY_SLUG = '__none__'
